import React from 'react';
import Header from "../../Layouts/Header";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import API from "../../Services/API";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import {FaFileInvoiceDollar} from "react-icons/fa";

const Requests = () => {
    const navigate = useNavigate();
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [requests, setRequests] = React.useState([]);
    const [tc, setTC] = React.useState('');
    const [country, setCountry] = React.useState(null);
    const [is_document, setIsDocument] = React.useState(null);
    const [destinations, setDestinations] = React.useState([]);
    const [dateFrom, setDateFrom] = React.useState(null);
    const [dateTo, setDateTo] = React.useState(null);

    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if(!token) {
            navigate('/login');
        }
        setIsLoaded(false)
        const params = {
            'list' : 1,
            'tracking_code' : tc,
            'orderBy' : 'id',
            country,
            is_document,
            dateFrom,
            dateTo
        }
        API.getRequests(params)
            .then((response) => {
                setRequests(response.data);
                setIsLoaded(true)

            })
            .catch((error) => {

                if (error.response) {
                    toast.error(error.response.data.message);
                    setTimeout(() => {
                        // window.history.back()
                    }, 400)
                } else {
                    toast.error(error.message);
                    setTimeout(() => {
                        // window.history.back()
                    }, 400)
                }
            });


    }, [tc , country, is_document, dateFrom, dateTo]);

    React.useEffect(() => {
        API.getDestinations()
            .then((response) => {
                setDestinations(response.data);
                setIsLoaded(true);
            })



    }, []);

    return (
        <React.Fragment>
            <Header/>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <section className="container mt-5">
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-floating mb-3">
                                    <input type="number" className="form-control" id="floatingInput"
                                           placeholder="tc" value={tc} onChange={(val) => setTC(val.target.value)} />
                                    <label htmlFor="floatingInput">Tracking Code</label>
                                </div>
                            </div>
                            <div className="col-md-4">

                                    <div className="form-floating mb-3">
                                        <select className="form-select" id="floatingSelect"
                                                onChange={(val) => {
                                                    setCountry(val.target.value)

                                                }}
                                        >
                                            <option value="0">All Countries</option>
                                            {
                                                destinations.map(dest => {
                                                    return (
                                                        <option value={dest.id}>{dest.title}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <label htmlFor="floatingSelect">Destination:</label>
                                    </div>

                            </div>
                            <div className="col-md-4">

                                    <div className="form-floating mb-3">
                                        <select className="form-select" id="floatingSelect"
                                                onChange={(val) => {
                                                    setIsDocument(val.target.value)

                                                }}
                                        >
                                            <option value="3">All Types</option>
                                            <option value="1">Document</option>
                                            <option value="0">Package</option>

                                        </select>
                                        <label htmlFor="floatingSelect">Type:</label>
                                    </div>

                            </div>
                            <div className="col-md-6">
                                <div className="form-floating mb-3">
                                    <input type="date" className="form-control" id="Date"
                                           placeholder="Date"
                                           onChange={(val) => {

                                               setDateFrom(val.target.value)
                                           }}
                                    />
                                    <label htmlFor="Date"> Date From:</label>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-floating mb-3">
                                    <input type="date" className="form-control" id="Date"
                                           placeholder="Date"
                                           onChange={(val) => {

                                               setDateTo(val.target.value)
                                           }}
                                    />
                                    <label htmlFor="Date"> Date To:</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 my-3">
                        <h2 className='fw-bold'>Requests List</h2>
                    </div>
                    <div className="col-12">
                        <table className="table table-hover">
                            <thead>
                            <tr>
                                <th scope="col" className='bg-primary text-white'>#</th>
                                <th scope="col" className='bg-primary text-white'>Service Provider</th>
                                <th scope="col" className='bg-primary text-white'>Tracking Code</th>
                                <th scope="col" className='bg-primary text-white'>Destination</th>
                                <th scope="col" className='bg-primary text-white'>Date</th>
                                <th scope="col" className='bg-primary text-white'>Type</th>
                                <th scope="col" className='bg-primary text-white'>Price</th>
                                <th scope="col" className='bg-primary text-white'>Status</th>
                                <th scope="col" className='bg-primary text-white'>Label</th>
                                <th scope="col" className='bg-primary text-white'>Receipt</th>

                            </tr>
                            </thead>
                            <tbody>
                            {
                                requests?.map((request, index) => {
                                    return (
                                        <tr
                                            key={request.id}
                                        >
                                            <td>{index + 1}</td>
                                            <td>{request.service_provider}</td>
                                            <td>{request.tracking_code}</td>
                                            <td>{request.country}</td>
                                            <td>{request.shipping_date}</td>
                                            <td>{request.is_document ? 'Document' : 'Package'}</td>
                                            <td>${request.total_price}</td>
                                            <td>
                                                <span style={{color: request.status?.color}}>
                                                    {request.status?.title}
                                                </span>
                                            </td>
                                            <td>
                                                <a href={request.label?.path} target="_blank"
                                                   title={request.label?.title}>
                                                    {request.label?.title}
                                                </a>
                                            </td>
                                            <td role='button' onClick={() => navigate(`/request/${request.id}`)} className='link-primary text-decoration-underline'>Receipt
                                            <FaFileInvoiceDollar className='mx-2' />
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
};

export default Requests;